/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import {
    number, shape, arrayOf, string, func, object, array, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CYOProgressBar from './CYOProgressBar';
import CYORadioItems from './CYORadioItems';
import CYOItems from './CYOItems';
import MobileCYOItem from './MobileCYOItems';
import ConnectedGraphqlFoodAddToCart from '../../GraphqlFoodAddToCart/GraphqlFoodAddToCart';
import GraphqlFoodProductDetailsTab from '../../GraphqlFoodDetailsUI/GraphqlFoodDetailsUI';

const styles = ({ palette }) => ({
    progressBarRoot: {
        position: 'fixed',
        bottom: '0',
        backgroundColor: palette.white || '#fff',
        zIndex: '111',
    },
    addTocartBtn: {
        position: 'fixed',
        bottom: '0',
        zIndex: '111',
    },
    cyoItemsWrapper: {
        padding: '0 15px 0 15px',
    },
    cyoItemsRoot: {
        paddingBottom: '34px',
        paddingTop: '15px',
    },
    categoryName: {
        color: palette.cms?.cyoMobileBtnColor || '#607767',
        fontWeight: '700',
        marginBottom: '15px',
    },
    cyoItems: {
        paddingBottom: '10px',
        '&:empty': {
            paddingBottom: '0',
        },
    },
    selectedCYOItems: {
        paddingTop: '10px',
        '&:last-child': {
            paddingBottom: '10px',
        },
    },
    selectedItemHeader: {
        color: palette.cms?.cyoMobileBtnColor || '#607767',
        fontWeight: '700',
    },
    productDetailsTab: {
        padding: '20px 10px 10px 10px',
    },
    makeSelectionBtn: {
        borderRadius: '50px',
        padding: '10px 20px 10px 20px',
        width: '100%',
        margin: '0 10px 0 10px',
        backgroundColor: palette.primaryButton || '#a1001a',
        color: palette.white || '#fff',
        fontWeight: '700',
    },
    closeModal: {
        float: 'right',
    },
});

class MobileCYOProductItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
        };
        this.myRef = React.createRef();
    }

    componentDidMount() {
        if (this.myRef.current) {
            this.myRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    componentDidUpdate() {
        if (this.myRef.current) {
            this.myRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    openModal = () => {
        this.setState({ openModal: true });
    }

    closeModal = () => {
        const { resetSelectedProducts, selectedItemsNames } = this.props;
        this.setState({ openModal: false });
        if (selectedItemsNames.length > 0) {
            resetSelectedProducts();
        }
    }

    // This function will return Out of stock text to be displayed below the CYO product
    getErrorMessage = (error, productId) => {
        if (!error) return '';

        // Handle the below error message from API response when - add to cart fails
        // FP001435: Product FP001435 is currently out of stock
        if (error.match(/currently out of stock/ig)) {
            const errorProductId = error.split(':')[0];
            const matchProduct = new RegExp(errorProductId, 'ig');
            if (productId.match(matchProduct)) {
                return 'Out of stock';
            }
        }

        return '';
    };

    render() {
        const {
            classes,
            progressBarData,
            totalProductSelected,
            maxSelectableForSku,
            cyoData,
            selectedBand,
            handleSelectedCyoProduct,
            getOptionSelectList,
            onRadioButtonChange,
            selectedItems,
            getTotalProductSelected,
            getTotalCategoryCount,
            cartError,
            selectedItemsNames,
            cyoSelectedComponents,
            handleRemoveProduct,
            handleMiniCartModalClick,
            selectedItemId,
            brandId,
            product,
            isBandItemSelected,
            handleMobileAgeVerification,
            hasWine,
        } = this.props;
        const { openModal } = this.state;
        const isTotalProdcutSelected = totalProductSelected === maxSelectableForSku;
        return (
            <Grid container>
                <Grid item xs={12} container justify="center">
                    <Button variant="contained" className={classes.makeSelectionBtn} onClick={() => this.openModal()}>Make Your Selection</Button>
                </Grid>
                <Grid className={classes.productDetailsTab}>
                    <GraphqlFoodProductDetailsTab
                        shortDescription={product?.shortDescription || ''}
                        productContents={product?.productContents || ''}
                        longDescription={product?.longDescription || ''}
                        productSkus={product?.productSkus || ''}
                    />
                </Grid>
                {openModal
                    && (
                        // Have to use data-testid to access DOM of dialog for test cases.
                        <Dialog open fullScreen data-testid="cyoDialog">
                            <div>
                                <div className={classes.cyoItemsRoot}>
                                    <div className={classes.cyoItemsWrapper}>
                                        <CloseIcon onClick={this.closeModal} className={classes.closeModal} />
                                        {selectedItemsNames.length > 0
                                            && (
                                                <div ref={this.myRef}>
                                                    <Typography className={classes.selectedItemHeader}>Selected Items</Typography>
                                                    {selectedItemsNames.map((selectedData) => (
                                                        <div key={selectedData.component.legacyId} className={classes.selectedCYOItems}>
                                                            <MobileCYOItem
                                                                selectedData={selectedData}
                                                                component={selectedData.component}
                                                                cyoGroup={selectedData.cyoGroup}
                                                                maxComponents={selectedData.maxQtyPerComponent}
                                                                selectedItems={selectedData.selectedItems}
                                                                handleSelectedCyoProduct={handleSelectedCyoProduct}
                                                                handleRemoveProduct={handleRemoveProduct}
                                                                selectedBand={selectedBand}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        {cyoData?.cyoGroup?.map((cyoGroup) => (
                                            <div key={cyoGroup?.name}>
                                                <Typography className={classes.categoryName}>{cyoGroup.name}</Typography>
                                                <div>
                                                    {cyoGroup.type === 'cyoBands'
                                                        ? cyoGroup?.components?.map((component) => (
                                                            <FormControl key={component.legacyId} component="fieldset">
                                                                <RadioGroup aria-label="cyoBands" name="cyoBands" value={selectedBand} onChange={onRadioButtonChange(component, maxSelectableForSku, cyoGroup)}>
                                                                    <CYORadioItems
                                                                        component={component}
                                                                        selectedBand={selectedBand}
                                                                    />
                                                                </RadioGroup>
                                                            </FormControl>
                                                        ))
                                                        : cyoGroup?.components?.map((component) => (
                                                            <div key={component.legacyId} className={classes.cyoItems}>
                                                                <CYOItems
                                                                    component={component}
                                                                    handleSelectedCyoProduct={handleSelectedCyoProduct}
                                                                    getOptionSelectList={getOptionSelectList}
                                                                    maxComponents={cyoData.maxQuantity || cyoGroup.numberofUnitsRequiredForComponent}
                                                                    cyoGroup={cyoGroup}
                                                                    selectedItems={selectedItems}
                                                                    totalProductSelected={cyoData.maxQuantity ? getTotalProductSelected(cyoData) : getTotalCategoryCount(cyoGroup)}
                                                                    cartError={cartError}
                                                                    displayView="mobile"
                                                                />
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {!isTotalProdcutSelected
                                        ? (
                                            <Grid item xs={12} container className={classes.progressBarRoot}>
                                                <CYOProgressBar
                                                    valueBufferBar={progressBarData}
                                                    totalProductSelected={totalProductSelected}
                                                    maxComponents={maxSelectableForSku}
                                                    displayView="mobile"
                                                />
                                            </Grid>
                                        )
                                        : (
                                            <Grid item xs={12} container className={classes.addTocartBtn}>
                                                <ConnectedGraphqlFoodAddToCart
                                                    handleMiniCartModalClick={handleMiniCartModalClick}
                                                    selectedItemId={selectedItemId}
                                                    brandId={brandId}
                                                    productType="cyo"
                                                    totalProductSelected={totalProductSelected}
                                                    maxComponents={maxSelectableForSku}
                                                    cyoSelectedComponents={cyoSelectedComponents}
                                                    product={product}
                                                    isBandItemSelected={isBandItemSelected()}
                                                    hasWine={hasWine}
                                                    handleMobileAgeVerification={handleMobileAgeVerification}
                                                />
                                            </Grid>
                                        )}
                                </div>
                            </div>
                        </Dialog>
                    )}
            </Grid>
        );
    }
}

MobileCYOProductItems.propTypes = {
    classes: object.isRequired,
    progressBarData: number.isRequired,
    totalProductSelected: number.isRequired,
    maxSelectableForSku: number.isRequired,
    cyoData: shape({
        maxQuantity: number.isRequired,
        cyoGroup: arrayOf(
            shape({
                name: string.isRequired,
                components: arrayOf(
                    shape({
                        id: string.isRequired,
                        legacyId: string.isRequired,
                        name: string.isRequired,
                        image: shape({
                            name: string.isRequired,
                            path: string.isRequired,
                        }),
                    }),
                ).isRequired,
            }),
        ).isRequired,
    }).isRequired,
    selectedBand: string.isRequired,
    onRadioButtonChange: func.isRequired,
    handleSelectedCyoProduct: func.isRequired,
    getOptionSelectList: func.isRequired,
    selectedItems: object.isRequired,
    getTotalProductSelected: func.isRequired,
    getTotalCategoryCount: func.isRequired,
    cartError: string.isRequired,
    selectedItemsNames: array.isRequired,
    cyoSelectedComponents: array,
    handleRemoveProduct: func.isRequired,
    handleMiniCartModalClick: func.isRequired,
    selectedItemId: string,
    brandId: string.isRequired,
    product: object.isRequired,
    isBandItemSelected: func.isRequired,
    handleMobileAgeVerification: func,
    hasWine: bool,
    resetSelectedProducts: func.isRequired,
};

MobileCYOProductItems.defaultProps = {
    selectedItemId: null,
    cyoSelectedComponents: [],
    handleMobileAgeVerification: () => {},
    hasWine: false,
};

export default withStyles(styles)(MobileCYOProductItems);
